/* MonKoku Maison · Produktseite: Duftpyramide (animiert) und Variantenwechsel per Probe-Karte */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!window.customElements.get('mk-pyramid')) {
    class MkPyramid extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.phase = 0;
        this.steps = 0;
        this.auto = this.hasAttribute('data-auto') && !reduce;
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-go]'));
        this.tiers = Array.prototype.slice.call(this.querySelectorAll('.mk-pyr__tier'));
        this.caps = Array.prototype.slice.call(this.querySelectorAll('[data-c]'));
        if (this.tabs.length < 2) { this.classList.add('is-live'); this.tiers.forEach(function (t) { t.classList.add('is-on'); }); return; }
        var self = this;
        this.tabs.forEach(function (b, i) {
          b.addEventListener('click', function () { self.stop(); self.go(i); });
          b.addEventListener('keydown', function (e) {
            var n = null;
            if (e.key === 'ArrowRight') n = (i + 1) % self.tabs.length;
            if (e.key === 'ArrowLeft') n = (i + self.tabs.length - 1) % self.tabs.length;
            if (n !== null) { e.preventDefault(); self.stop(); self.go(n); self.tabs[n].focus(); }
          });
        });
        this.classList.add('is-live');
        this.go(0);
        if (this.auto && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (es) {
            es.forEach(function (e) { if (e.isIntersecting) self.start(); else self.pause(); });
          }, { threshold: 0.6 });
          this.io.observe(this);
        }
      }
      disconnectedCallback() { this.pause(); if (this.io) this.io.disconnect(); }
      go(i) {
        this.phase = i;
        this.tabs.forEach(function (b, k) { b.setAttribute('aria-selected', k === i ? 'true' : 'false'); b.tabIndex = k === i ? 0 : -1; });
        this.tiers.forEach(function (t, k) {
          t.classList.remove('is-on');
          if (k === i) { void t.offsetWidth; t.classList.add('is-on'); }
        });
        this.caps.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
      }
      start() {
        if (!this.auto || this.timer || this.steps >= 6) return;
        var self = this;
        if (!this._started) { this._started = true; this.go(this.phase); }
        this.classList.add('is-playing');
        this.timer = setInterval(function () {
          self.steps += 1;
          if (self.steps >= 6) { self.go(0); self.stop(); return; }
          self.go((self.phase + 1) % self.tiers.length);
        }, 4600);
      }
      pause() { if (this.timer) { clearInterval(this.timer); this.timer = null; } this.classList.remove('is-playing'); }
      stop() { this.auto = false; this.pause(); }
    }
    window.customElements.define('mk-pyramid', MkPyramid);
  }

  /* Probe zuerst: passende Variante im Variantenwähler anwählen */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-mk-pick]') : null;
    if (!b) return;
    e.preventDefault();
    var want = b.getAttribute('data-mk-pick');
    var scope = b.closest('product-rerender') || document;
    var inputs = scope.querySelectorAll('variant-picker input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var lab = document.querySelector('label[for="' + inputs[i].id + '"]');
      var txt = ((lab && lab.textContent) || '').replace(/\s+/g, '').toLowerCase();
      if (txt === want) { inputs[i].click(); break; }
    }
  });

  /* Sticky-Kaufleiste: Beschriftung (Vorbestellen) und gewählte Variante aus dem Hauptformular übernehmen */
  function syncSticky() {
    var bar = document.querySelector('product-sticky-bar');
    if (!bar) return;
    var main = document.querySelector('.product-info buy-buttons button[type="submit"]');
    var sb = bar.querySelector('button[type="submit"]');
    if (main && sb) {
      var t = main.textContent.trim();
      if (t && sb.textContent.trim() !== t) sb.textContent = t;
    }
    var info = bar.querySelector('.product-sticky-bar__info .v-stack');
    var radios = document.querySelectorAll('variant-picker input[type="radio"]');
    var checked = document.querySelector('variant-picker input[type="radio"]:checked');
    var lab = checked && document.querySelector('label[for="' + checked.id + '"]');
    var vt = lab ? lab.textContent.trim() : '';
    var tag = bar.querySelector('.mk-sticky-v');
    if (info && vt && radios.length > 1) {
      if (!tag) { tag = document.createElement('span'); tag.className = 'mk-sticky-v'; info.appendChild(tag); }
      if (tag.textContent !== vt) tag.textContent = vt;
    }
  }
  function watchSticky() {
    var bar = document.querySelector('product-sticky-bar');
    if (!bar) return;
    syncSticky();
    var host = bar.parentNode;
    if (host && 'MutationObserver' in window && !host._mkWatch) {
      host._mkWatch = true;
      new MutationObserver(function () { syncSticky(); }).observe(host, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('variant:change', function () { setTimeout(syncSticky, 60); setTimeout(syncSticky, 500); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchSticky); else watchSticky();
})();